import { useState, useEffect } from 'react'
import api from '../lib/api'
import './TitanTrackRecord.css'

const TITANS = {
  grok: { name: 'GROK', icon: '⚡', color: '#d33682' },
  opus: { name: 'OPUS', icon: '⚖️', color: '#d4af37' },
}

export default function TitanTrackRecord({ topic = null }) {
  const [grokStats, setGrokStats] = useState(null)
  const [opusStats, setOpusStats] = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const fetchStats = async () => {
      setLoading(true)
      try {
        const [grok, opus] = await Promise.all([
          api.getModelTrackRecord('grok', topic),
          api.getModelTrackRecord('opus', topic),
        ])
        setGrokStats(grok)
        setOpusStats(opus)
      } catch (err) {
        console.warn('Failed to fetch track records:', err)
        // Use mock data
        setGrokStats({ wins: 4, losses: 2, accuracy: 0.67 })
        setOpusStats({ wins: 5, losses: 3, accuracy: 0.625 })
      } finally {
        setLoading(false)
      }
    }

    fetchStats()
  }, [topic])

  if (loading) {
    return (
      <div className="titan-track-record loading">
        <div className="loading-spinner"></div>
      </div>
    )
  }

  return (
    <div className="titan-track-record">
      <div className="track-header">
        <h3>Titan Track Record</h3>
        {topic && <span className="track-topic">{topic}</span>}
      </div>

      <div className="titan-stats-grid">
        {/* Grok Stats */}
        <div className="titan-stat-card grok">
          <div className="titan-header">
            <span className="titan-icon">{TITANS.grok.icon}</span>
            <span className="titan-name">{TITANS.grok.name}</span>
          </div>
          <div className="titan-record">
            <span className="wins">{grokStats?.wins || 0}W</span>
            <span className="separator">-</span>
            <span className="losses">{grokStats?.losses || 0}L</span>
          </div>
          <div className="titan-accuracy">
            <div className="accuracy-bar">
              <div
                className="accuracy-fill grok"
                style={{ width: `${(grokStats?.accuracy || 0) * 100}%` }}
              />
            </div>
            <span className="accuracy-value">
              {Math.round((grokStats?.accuracy || 0) * 100)}%
            </span>
          </div>
        </div>

        {/* VS Badge */}
        <div className="vs-divider">VS</div>

        {/* Opus Stats */}
        <div className="titan-stat-card opus">
          <div className="titan-header">
            <span className="titan-icon">{TITANS.opus.icon}</span>
            <span className="titan-name">{TITANS.opus.name}</span>
          </div>
          <div className="titan-record">
            <span className="wins">{opusStats?.wins || 0}W</span>
            <span className="separator">-</span>
            <span className="losses">{opusStats?.losses || 0}L</span>
          </div>
          <div className="titan-accuracy">
            <div className="accuracy-bar">
              <div
                className="accuracy-fill opus"
                style={{ width: `${(opusStats?.accuracy || 0) * 100}%` }}
              />
            </div>
            <span className="accuracy-value">
              {Math.round((opusStats?.accuracy || 0) * 100)}%
            </span>
          </div>
        </div>
      </div>
    </div>
  )
}
